import barA from "../assets/barA.avif";
import barB from "../assets/barB.avif";
import barC from "../assets/barC.avif";
import barD from "../assets/barD.avif";
import barE from "../assets/barE.avif";
import barF from "../assets/barF.avif";
import barG from "../assets/barG.avif";
import barH from"../assets/barH.avif";
import barL from"../assets/barL.avif";
import barM from"../assets/barM.avif";
import drinkA from"../assets/drinkA.avif";
import drinkB from"../assets/drinkB.avif";
import drinkC from"../assets/drinkC.avif";
import drinkD from"../assets/drinkD.avif";
import drinkE from"../assets/drinkE.avif";
import drinkF from"../assets/drinkF.avif";
import drinkG from"../assets/drinkG.avif";
import drinkH from"../assets/drinkH.avif";
import fishA from"../assets/fishA.avif";
import fishB from"../assets/fishB.avif";
import fishC from"../assets/fishC.avif";
import fishD from"../assets/fishD.avif";
import menuA from"../assets/menuA.png";
import menuB from"../assets/menuB.png";
import menuC from"../assets/menuC.png";
import menuD from"../assets/menuD.png";
import menuF from"../assets/menuE.png";

export default{
barA,
barB,
barC,
barD,
barE,
barF,
barG,
barH,
barL,
barM,
drinkA,
drinkB,
drinkC,
drinkD,
drinkE,
drinkF,
drinkG,
drinkH,
fishA,
fishB,
fishC,
fishD,
menuA,
menuB,
menuC,
menuD,
menuF,
}